'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'sunset';
var width = 576;
var height = 512;
var aliases = [127751];
var unicode = 'f767';
var svgPathData = 'M369.4 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-102.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64zM200.6 200.1c-6.7-4.4-15.1-5.2-22.5-2.2s-12.8 9.6-14.3 17.4L143 318.6 39.7 339.4c-7.8 1.6-14.4 7-17.4 14.3s-2.2 15.8 2.2 22.5l26.4 39.8 118.8 0c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80l118.8 0 26.4-39.8c4.4-6.7 5.2-15.1 2.2-22.5s-9.6-12.8-17.4-14.3L433.8 318.6 413 215.3c-1.6-7.8-7-14.4-14.3-17.4s-15.8-2.2-22.5 2.2l-87.8 58.2-87.8-58.2zM32.4 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-464 0c-13.3 0-24 10.7-24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;